import App from './App.svelte';
import { getCategoryId, protalRead, protalToken, getUserToken } from '$api'
import QueryUtils from "query-utils";
__PlatformLoginDep.$register(async function (gid, userName) {
	console.log("有用户信息了");
	if (gid) {
		await protalToken()
		isArticleJumpCB()
	}
});
async function isArticleJumpCB() {
	let articleId = Array.from(
		QueryUtils.getParamsByKey("readedArticle")
	).join("");
	if(articleId) {
		let list = await getCategoryId('视频学习')
		let t = list.find(article => article.id === articleId)
		protalRead(t).then(() => {
			window.location.href = t.url;
		});
	}
}

((global) => {
	global['secondary-video-list'] = {
		bootstrap: (props) => {
			console.log('secondary-video-list props bootstrap', props);
			return Promise.resolve();
		},
		mount: (props) => {
			console.log('secondary-video-list props mount', props);
			var cardWidth = 386
			var everyListNum = 0
			var currentCardWidth = 0
			currentCardWidth = (everyListNum * cardWidth) + 16 * (everyListNum - 1)
			while (currentCardWidth < props.container.offsetWidth) {
				if (((everyListNum + 1) * cardWidth) + 16 * (everyListNum) < props.container.offsetWidth) {
					everyListNum++
					currentCardWidth = (everyListNum * cardWidth) + 16 * (everyListNum - 1)
				} else {
					break
				}
			}
			var app = new App({
				target: props.container,
				props: {
					list: [],
					everyListNum: everyListNum,
					cardWidth: cardWidth,
					isLoading: false
				}
			});
			console.log('props.container.offsetWidth', props.container.offsetWidth)
			console.log('everyListNum', everyListNum)
			let articleId = '' + QueryUtils.getParamsByKey("readedArticle");
			if (articleId) {
				app.$$set({ isLoading: true})
			} else {
				getCategoryId('视频学习').then(list => {
					app.$$set({ list: list })
				});
			}
			return Promise.resolve();
		},
		unmount: () => {
			console.log('secondary-video-list purehtml unmount');
			return Promise.resolve();
		},
	};
})(window);